// @flow
import { generateKeyframesCSS } from 'app/common/react/components/growth/activation/animations/animationsUtils';

export type ValidColors = 'yellow' | 'orange' | 'green' | 'blue' | 'purple';

// From PDS
export const BUBBLE_COLORS = {
  yellow: '#FAB904',
  orange: '#FF6400',
  green: '#0FA573',
  blue: '#4A90E2',
  purple: '#B469EB',
};

const CLASSNAME = 'DelightfulBubbles__';

const pickNextColor = (colors: Array<ValidColors>, searchColor: ValidColors): ValidColors => {
  const countItems = colors.length;
  const nextItemPosition =
    colors.indexOf(searchColor) + 1 >= countItems ? 0 : colors.indexOf(searchColor) + 1;
  return colors[nextItemPosition];
};

const generateColorChangeKeyframesRules = (): Array<string> => {
  const colorChangeKeyframesRules = Object.keys(BUBBLE_COLORS).map((initialColor: ValidColors) => {
    const endColor = pickNextColor(Object.keys(BUBBLE_COLORS), initialColor);
    return `${CLASSNAME}colorChange_${initialColor} {
      0% {
        background-color: ${BUBBLE_COLORS[initialColor]};
      }
      50% {
        background-color: ${BUBBLE_COLORS[endColor]};
      }
    }
    `;
  });
  return colorChangeKeyframesRules;
};

const fadeInKeyframes = `${CLASSNAME}fadeIn {
  to {
    opacity: 1;
  }
}
`;

const growShrinkKeyframes = `${CLASSNAME}growShrink {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
`;

const swirlKeyframes = `${CLASSNAME}swirl {
  0% {
    transform: rotate(0deg) translateX(-50%);
  }
  100% {
    transform: rotate(-360deg) translateX(-50%);
  }
}
`;

const baseKeyframes = [
  fadeInKeyframes,
  growShrinkKeyframes,
  swirlKeyframes,
  ...generateColorChangeKeyframesRules(),
];

export const DELIGHTFUL_BUBBLES_KEYFRAMES = generateKeyframesCSS(baseKeyframes);

export const DelightfulBubblesStyles = (
  delay: number,
  diameter: number,
  height: number,
  initialColor: ValidColors,
  radius: number,
  width: number,
  xOffset: number,
  yOffset: number,
) => ({
  bubblePositionStyles: {
    position: 'absolute',
    marginLeft: `${width / 2 - radius}px`,
    marginTop: `${height / 2 - radius}px`,
    left: `${xOffset}px`,
    top: `${yOffset}px`,
  },
  bubbleSwirlStyles: {
    animation: `${CLASSNAME}swirl 6s ease-in-out ${delay}s infinite forwards`,
    WebkitAnimation: `${CLASSNAME}swirl 6s ease-in-out ${delay}s infinite forwards`,
  },
  bubbleGrowShrinkStyles: {
    transform: 'scale(0)',
    WebkitTransform: 'scale(0)',
    animation: `${CLASSNAME}growShrink 6s ease-in-out ${delay}s infinite alternate`,
    WebkitAnimation: `${CLASSNAME}growShrink 6s ease-in-out ${delay}s infinite alternate`,
  },
  bubbleShapeStyles: {
    height: `${diameter}px`,
    width: `${diameter}px`,
    borderRadius: '50%',
    backgroundColor: BUBBLE_COLORS[initialColor],
    opacity: 0,
    animation: `${CLASSNAME}colorChange_${initialColor} 12s steps(1, start) ${delay}s infinite forwards,
      ${CLASSNAME}fadeIn 3s linear ${delay}s 1 forwards`,
    WebkitAnimation: `${CLASSNAME}colorChange_${initialColor} 12s steps(1, start) ${delay}s infinite forwards,
      ${CLASSNAME}fadeIn 3s linear ${delay}s 1 forwards`,
  },
});

export default null;
